import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function CustomerForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('id');
  const isEditMode = !!customerId;
  const [formData, setFormData] = useState({
    name: isEditMode ? 'Acme Corporation' : '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: 'Sri Lanka',
    status: 'active' as const
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Saving customer:', formData);
    navigate('/customers');
  };
  return <div className="space-y-6" data-id="element-5657">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-5658">
        <button onClick={() => navigate('/customers')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900" data-id="element-5659">
          <ArrowLeftIcon size={20} data-id="element-5660" />
          Back to Customers
        </button>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-5661">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-5662">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-5663">
            {isEditMode ? 'Edit Customer' : 'Create New Customer'}
          </h2>
          <div className="space-y-6" data-id="element-5664">
            {/* Basic Information */}
            <div data-id="element-5665">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-5666">
                Basic Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5667">
                <div data-id="element-5668">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5669">
                    Customer Name *
                  </label>
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5670" />
                </div>
                <div data-id="element-5671">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5672">
                    Email *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5673" />
                </div>
                <div data-id="element-5674">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5675">
                    Phone
                  </label>
                  <input type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} placeholder="+60 12 345 6789" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5676" />
                </div>
                <div data-id="element-5677">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5678">
                    Status
                  </label>
                  <select value={formData.status} onChange={e => setFormData({
                  ...formData,
                  status: e.target.value as 'active' | 'inactive'
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5679">
                    <option value="active" data-id="element-5680">Active</option>
                    <option value="inactive" data-id="element-5681">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Address */}
            <div data-id="element-5682">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-5683">
                Address
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5684">
                <div className="md:col-span-2" data-id="element-5685">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5686">
                    Street Address
                  </label>
                  <input type="text" value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} placeholder="123 Business Street" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5687" />
                </div>
                <div data-id="element-5688">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5689">
                    City
                  </label>
                  <input type="text" value={formData.city} onChange={e => setFormData({
                  ...formData,
                  city: e.target.value
                })} placeholder="Colombo" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5690" />
                </div>
                <div data-id="element-5691">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-5692">
                    Country
                  </label>
                  <input type="text" value={formData.country} onChange={e => setFormData({
                  ...formData,
                  country: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-5693" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3" data-id="element-5694">
          <button type="button" onClick={() => navigate('/customers')} className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-5695">
            Cancel
          </button>
          <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-5696">
            {isEditMode ? 'Update Customer' : 'Create Customer'}
          </button>
        </div>
      </form>
    </div>;
}